module.exports = __webpack_public_path__ + "img/Metastasis-PDAC_GSE111672.63901d5c.png";